import type { SystemStyleObject } from "@chakra-ui/react";

/** Subtle primary dot grid layered over sidebar gradients. */
const DEFAULT_DOT_PATTERN =
  "radial-gradient(circle, rgba(91, 33, 244, 0.11) 1px, transparent 1px)";

const DEFAULT_DOT_SIZE = "20px 20px";

const DEFAULT_SHELL_GRADIENT =
  "linear-gradient(145deg, #F3EEFF 0%, #E8E2F6 24%, #f1f5f9 58% , #A389FF 68%, #7A5CFF 80%, #5B21F4 100%)";

const BLACK_DOT_PATTERN =
  "radial-gradient(circle, rgba(255, 255, 255, 0.06) 1px, transparent 1px)";

const WHITE_DOT_PATTERN =
  "radial-gradient(circle, rgba(91, 33, 244, 0.06) 1px, transparent 1px)";

function layeredBackground(
  dotPattern: string,
  gradient: string,
): SystemStyleObject {
  return {
    backgroundImage: `${dotPattern}, ${gradient}`,
    backgroundRepeat: "repeat, no-repeat",
    backgroundSize: `${DEFAULT_DOT_SIZE}, cover`,
    backgroundPosition: "0 0, 0 0",
  };
}

export const defaultShellBackground = layeredBackground(
  DEFAULT_DOT_PATTERN,
  DEFAULT_SHELL_GRADIENT,
);

export const blackShellBackground: SystemStyleObject = layeredBackground(
  BLACK_DOT_PATTERN,
  "linear-gradient(180deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)",
);

export const whiteShellBackground: SystemStyleObject = layeredBackground(
  WHITE_DOT_PATTERN,
  "linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 50%, #F5F5F5 100%)",
);

/** @deprecated Use sidebarTheme tokens instead. Kept for backward compatibility. */
export { defaultShellBackground as sidebarShellBackground };
